/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BulkUpdateRestService, BulkUpdateTaskType } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { ButlListItem, ButlMessage } from './butl.model';

@Injectable()
export class ButlListBusinessService implements InitViewService {
  constructor(private bulkUpdateRest: BulkUpdateRestService,
              private gridLayoutService: GridLayoutService,
              private dictionaryService: DictionaryService) {
  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('bulkUpdateTasks'),
      bulkUpdateTaskType: this.dictionaryService.getByEnum(BulkUpdateTaskType),
    };
  }

  get(id: ID): Observable<ButlMessage> {
    return this.bulkUpdateRest.getDetailedMessage(id);
  }

  findAllAsDataSource(filter: any): SlicedDataSource<ButlListItem> {
    return this.bulkUpdateRest.findAllLogsAsDataSource(filter);
  }
}
